/**
 * Background Visual
 *
 * @author Space-Time Inc.
 * @version 2022-07-25
 */

// const opening_wrap = document.querySelector('.page-template-front-page .opening');
const wrap     = document.querySelector('.page-template-front-page .loading-wrap');
const frame = document.querySelector('.page-template-front-page .lottie-frame');

const agent = window.navigator.userAgent.toLowerCase();
// console.log( opening_wrap );
// }
window.addEventListener('DOMContentLoaded', () => {

	var params= {
		container: frame,
		renderer: "svg",
		loop: 0,
		autoplay: false,
		// loop: true,
		// autoplay: true,
		path     : TOP_VISUAL.asset_url + 'lottie/animation-top.json',
	}
	var animation = lottie.loadAnimation(params);

	if (!sessionStorage.getItem('disp')) {
		var opening =document.createElement('div');
		opening.classList.add('opening');
		if(wrap) {
			wrap.appendChild(opening);
		}

		window.addEventListener('load', function () {
			if (agent.indexOf('safari') !== -1 && agent.indexOf('chrome') === -1){
				setTimeout(opening_complete, 2000);
			} else {
				setTimeout(opening_complete, 3000);
			}
	
			setTimeout(animation_start, 6000);
			setTimeout(animation_fade, 7000);
			setTimeout(animation_compleate, 7800);
		}, false);
		//sessionStorage.setItem('disp', 'on');
	} else {
		window.addEventListener('load', function () {
			if(wrap) {
				wrap.classList.add("active");
			}
			animation_start();
			setTimeout(animation_fade, 2000);
			setTimeout(animation_compleate, 2500);
		}, false);
	}


	function opening_complete() {
		opening.classList.add("done");
	}
	function animation_start() {
		animation.play();
	}
	function animation_fade() {
		if(frame) {
			frame.classList.add("fade");
		}
	}
	function animation_compleate() {
		if(frame) {
			frame.classList.add("done");
		}
	}
});